<script setup lang="ts">
import ModuleManager from './components/manager/ModuleManager.vue';
</script>

<template>
  <ModuleManager />
</template>
